@let company = company$ | async;

@if (companyLogo != null || company?.logo != null) {
  <img [src]="companyLogo ?? company?.logo" alt="company-logo-image" />
}
<div>
  <p>
    When calculating the biggest saving, we have relied on the information which you provided to us
    when you last updated your Mortgage Monitor account.
    <br />
    <br />
    If your needs or circumstances have changed since then please update your information or speak
    to a qualified mortgage advisor before acting on this advice. We will let you know if your
    updated information changes our recommendation.
    <br />
    <br />
    Think carefully before securing other debts against your home. Your home or property may be
    repossessed if you do not keep up repayments on your mortgage.
    <br />
    <br />
    Our website is completely free for you to use, but we may receive a commission from the provider
    if you successfully take out a new deal.
    <br />
    <br />
  </p>
  <span [innerHtml]="company?.footer"></span>
</div>
